import { render, staticRenderFns } from "./checkTrafficViolation.vue?vue&type=template&id=2a5f1331&scoped=true&"
import script from "./checkTrafficViolation.vue?vue&type=script&lang=js&"
export * from "./checkTrafficViolation.vue?vue&type=script&lang=js&"
import style0 from "./checkTrafficViolation.vue?vue&type=style&index=0&id=2a5f1331&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5f1331",
  null
  
)

export default component.exports